export default "__VITE_ASSET__fce4de70__"